export default __webpack_public_path__ + "static/media/2.ec875991.webp";